import { startSpan } from '@sentry/react'
import { getApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'

interface ApiRequest<TVariables = never> {
  readonly type: string
  readonly value?: TVariables
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const invokeApi = async <TData, TVariables>(type: string, variables?: TVariables) => {
  const apiCallable = httpsCallable<ApiRequest<TVariables>, TData>(
    getFunctions(getApp(), 'northamerica-northeast1'),
    'onr-api'
  )
  const result = await startSpan({ name: `api`, attributes: { type } }, () =>
    apiCallable(variables ? { type, value: variables } : { type })
  )
  return result.data
}
